'use client';

import Description from '@/components/Description';
import { formatDate } from '@/utils/helpers';
import type { SoftTag } from '../utils/match-maker.types';

interface SoftTagDetailProps {
  softTag: SoftTag;
}

export const SoftTagDetailCard: React.FC<SoftTagDetailProps> = ({
  softTag,
}) => {
  return (
    <div className="flex flex-col p-4 gap-4">
      <Description
        title="Soft tag name"
        description={softTag.tag_name}
        boldDescription
      />
      <div className="grid grid-cols-2 gap-4">
        <Description
          title="Date of creation"
          description={formatDate(softTag.created_at)}
          boldDescription
        />
        <Description
          title="Last update"
          description={formatDate(softTag.updated_at || '')}
          boldDescription
        />
        <Description
          title="Data type"
          description={softTag.type || '-'}
          boldDescription
        />
        <Description
          title="Site"
          description={softTag.site_id || '-'}
          boldDescription
        />
        <Description
          title="Area"
          description={softTag.area || '-'}
          boldDescription
        />
        <Description
          title="Production unit"
          description={softTag.production_unit || '-'}
          boldDescription
        />
        <Description
          title="ID"
          description={softTag.timeseries_id || '-'}
          boldDescription
          className="col-span-2"
        />
      </div>
      <Description
        title="Description"
        description={softTag.tag_description || '-'}
      />
    </div>
  );
};
